function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("Hey there! My name is Vlad Albert, I'm a full stack web developer and UI/UX enthusiast.")]),_vm._v(" "),_c('p',[_vm._v("I'm very passionate about building robust apps, with practical and innovative functionalities for the end users. At the core I'm a problem solver and a big picture thinker.")]),_vm._v(" "),_c('p',[_vm._v("What I enjoy most is bringing ideas into reality and the whole creative process behind it (from "),_c('em',[_vm._v("designing databases")]),_vm._v(" to "),_c('em',[_vm._v("CSS animations")]),_vm._v(" and everything in between).")]),_vm._v(" "),_c('p',[_vm._v("If you want to know more technical details about my skills check out my "),_c('a',{attrs:{"href":"https://www.vladalbert.com/","target":"_blank"}},[_vm._v("resume")]),_vm._v(".")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"technologies":["react","redux","javascript","nodejs","vue","sass","python","django","css3","html5","postgres","mysql"]},
    
      body: "Hey there! My name is Vlad Albert, I'm a full stack web developer and UI/UX enthusiast.\r\n\r\nI'm very passionate about building robust apps, with practical and innovative functionalities for the end users. At the core I'm a problem solver and a big picture thinker. \r\n\r\nWhat I enjoy most is bringing ideas into reality and the whole creative process behind it (from *designing databases* to *CSS animations* and everything in between).\r\n\r\nIf you want to know more technical details about my skills check out my <a href=\"https://www.vladalbert.com/\" target=\"_blank\">resume</a>.",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }